/* eslint-disable */
const u = navigator.userAgent
export const isAndroid = u.indexOf('Puze caifu-android') > -1 || u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
// export const isInPZAPP = u.indexOf('puze_fund_app') > -1
export const isInPZAPP = u.indexOf('Puze caifu-ios') > -1 || u.indexOf('Puze caifu-android') > -1
export const mobileKeywords = [
  'Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Opera Mini',
  'Mobile', 'Tablet'
]

export const isInMobile = (() => {
  for (let keyword of mobileKeywords) {
    if (u.indexOf(keyword) >= 0) {
        return true;
    }
  }
  return false
})()

// 获取app版本号
export const getVersion = () => {
  const versionMatch = u.match(/versionCode=([\d\.]+)/)
  const version = versionMatch ? versionMatch[1] : null;
  if (version) {
    const versionNumber = parseInt(version.replace(/\./g, ''), 10)
    return versionNumber
  } else {
    return version
  }
}
function setupWebViewJavascriptBridge (callback) {
  // Android使用
  if (isAndroid) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        return callback(window.WebViewJavascriptBridge)
      }, false)
    }
  } else {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    const WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
}

function queryUrl (url) {
  const result = {}
  let arr
  let str
  let key
  let key_arr
  let len
  if (url.indexOf('?') !== -1) {
    arr = url.split('?')
    str = arr[1]
    arr = str.split('&')
    len = arr.length
    if (len > 0) {
      for (let i = 0; i < len; i++) {
        key = arr[i]
        key_arr = key.split('=')
        result[key_arr[0]] = key_arr[1]
      }
    }
  }
  return result
}

// 此处判断在app内部是厚与和泽物 其他渠道app为否
export function isInApp () {
  return u.indexOf('FlagshipFinancial') > -1 || u.indexOf('FlagshipLender') > -1
}

export function callHandler (CMD, params) {
  return new Promise(function (resolve, reject) {
    try {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge['callHandler'](CMD, params, function (resStr) {
          if (Object.prototype.toString.call(resStr) !== '[object String]') {
            resStr = JSON.stringify(resStr)
          }
          // res 是个字符串
          resolve(resStr)
        })
      })
      // bridge 超时操作
      const timer = setTimeout(() => {
        resolve(queryUrl(location.href))
        clearTimeout(timer)
      }, 10000)
    } catch (e) {
      // 初始化失败
      reject('BRIDGE_LOADED_ERROR')
    }
  })
}

export function registerHandler (CMD, callback) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge['registerHandler'](CMD, function (resStr) {
        if (Object.prototype.toString.call(resStr) !== '[object String]') {
          resStr = JSON.stringify(resStr)
        }
        // res 是个字符串
        if (
          Object.prototype.toString.call(callback) === '[object Function]' ||
          Object.prototype.toString.call(callback) === '[object AsyncFunction]'
        ) {
          return callback(resStr)
        }
        console.log('registerHandler参数错误, callback is not a function')
      })
    })
  } catch (e) {
    console.log(e.message)
  }
}


/**
 * 退出登录
 */
export function toLoginOut(params = {}) {
  return callHandler("SMZT_logout", {...params});
}


/**
 * 打电话
 */
export function toCallPhome(phone) {
  return callHandler("tbCallPhone", phone);
}


/**
 * 登录成功
 */
export function pzLoginSuccess(opt) {
  return callHandler("pzLoginSuccess", opt);
}


/**
 * 退出登录
 */
export function pzLoginOut() {
  return callHandler("pzLoginOut", {})
}

/**
 * 打开h5页面
 */
export function pzOpenWebPage(opt) {
  return callHandler("pzOpenWebPage", opt)
}

/**
 * 滑动验证码成功
 */
export function pzSliderVertifySuccess() {
  return callHandler("pzSliderVertifySuccess", {})
}


/**
 * 滑动验证码错误
 */
export function pzSliderVertifyError(opt) {
  return callHandler("pzSliderVertifyError", opt)
}


/**
 * 关闭滑动验证码的webview
 */
export function pzSliderVertifyClose() {
  return callHandler("pzSliderVertifyClose", {})
}

/**
 * 关闭webview
 */
export function pzWebPageClose() {
  return callHandler("pzWebPageClose", {})
}

/**
 * 打开原生页面
 * **/
export function openAppPage(params) {
  return callHandler("tbH5OpenAppPage", {
    ios: params.ios,
    android: params.android,
    flutter: params.flutter,
  });
}

/**
 * h5通过app跳转到别的h5,  参数复制 要深复制
 * **/
 export function openH5Page(url, params) {
  const options = {};
  if (typeof url === "object") {
    params = url;
    url = "";
  }
  Object.assign(
    options, {
      page: "webview",
      pageParams: {
        url: url,
        login: "1",
      },
    },
    params
  );
  return callHandler("tbH5GoAppPages", options);
}

/**
 * 跳转到几个主页
 * barType main:主页 publicFund:公募 privateFund：私募 mine:我的
 * **/
export function pzNavigationBarType(params = {}) {
  return callHandler("pzNavigationBarType", params);
}

/**
 * 打开原生页面
 * page login_page 登录
 * **/
 export function pzOpenNativePage(params = {}) {
  return callHandler("pzOpenNativePage", params);
}

/**
 * 打开原生页面
 * 返回到指定页面（H5页面传地址，原生页面传路由）
 * **/
 export function pzBackPageUrl(pageURl = '') {
  return callHandler("pzBackPageUrl", pageURl);
}


/**
 * 隐藏标题栏返回按钮
 * **/
 export function pzHideBackButton(params = {}) {
  return callHandler("pzHideBackButton", params);
}

/**
 * 唤起微信小程序
 * **/
export function pzLaunchMiniProgram(params = {}) {
  return callHandler("pzLaunchMiniProgram", params);
}


/**
 * 下载图片
 * @param {any} params={}
 * @returns {any}
 */
export function pzDownloadImage(params = {}) {
  return callHandler("pzDownloadImage", params);
}


/**
 * 打开PDF
 * @param {any} params={
 *  url: 'https://www.baidu.com',
 *  ext: 'pdf',
 * }
 * @returns {any}
 */
export function SMZT_download(params = {}) {
  return callHandler("SMZT_download", params);
}

/**
 * 分享配置
 * @param {any} params={}
 * @returns {any}
 */
export function pzShareConfig(params = {}) {
  return callHandler("pzShareConfig", params);
}

/**
 * 海报分享配置
 * @param {any} params={}
 * @returns {any}
 */
export function pzSharePlacard(params = {}) {
  return callHandler("pzSharePlacard", params);
}

/**
 * 打开银行app
 * @param {any} params={}
 * @returns {any}
 */
export function pzOpenBankApp(params = {}) {
  return callHandler("pzOpenBankApp", params);
}

/**
 * iOS webview是否显示底部安全边距
*/
export function pzShowBottomSafeArea(params = {}) {
  return callHandler("pzShowBottomSafeArea", params);
}
export function pzShareInfo(params = {}) {
  return callHandler("pzShareInfo", params);
}

export function pzOpenLivePage(params = {}) {
  return callHandler("openLivePage", params);
}

/**
 * @param {any} params={
 * userNo: '',
 * orderNo: '',
 * fileIds: '',
 * }
 * @returns {any}
 * userNo 如果后期确认使用customerNo，可不传
*/
export function pzTTDSign (params = {}) {
  return callHandler("ttdSign", params);
}
/**
 * 为H5提供app信息和用户信息
 * **/
export function YxAppUserInfo() {
  return callHandler("YxAppUserInfo");
}

/**
 * app显示在标题栏图标提供事件
 * @param {any} params={
 * showIcon: '',
 * type: '',
 * functionName: '',
 * }
 * **/
export function pzShowTitleBarIcon(params = {}) {
  return callHandler("showTitleBarIcon", params);
}